import { render, staticRenderFns } from "./CreateBookingBreadcrumb.vue?vue&type=template&id=45222a42&scoped=true&lang=html&"
import script from "./CreateBookingBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./CreateBookingBreadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./CreateBookingBreadcrumb.vue?vue&type=style&index=0&id=45222a42&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45222a42",
  null
  
)

export default component.exports